import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared";

import {
  DiscussionMetaSectionComponent,
  DiscussionMetaPanelComponent,
} from "./discussion-meta-section";

import { DiscussionViewerComponent } from "./discussion-viewer.component";
import { DiscussionContentSectionComponent } from "./discussion-content-section/discussion-content-section.component";
import { ViewableDiscussionResolver } from "../../../shared/services";
import { DiscussionViewerRoutingModule } from "./discussion-viewer-routing.module";

@NgModule({
  imports: [DiscussionViewerRoutingModule, SharedModule],
  declarations: [
    DiscussionViewerComponent,
    DiscussionMetaPanelComponent,
    DiscussionMetaSectionComponent,
    DiscussionContentSectionComponent,
  ],
  providers: [ViewableDiscussionResolver],
})
export class DiscussionViewerModule {}
